import * as React from 'react';
import PropTypes from 'prop-types'
import * as Toast from '@radix-ui/react-toast';
import { useLocation, globalHistory } from '@reach/router';
import './styles.scss';


function usePrevious(value) {
  const ref = React.useRef();
  React.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}


const ToastProductChange = React.memo(function ToastProductChangeMemo({
  currentProduct
}){

  
  const [open, setOpen] = React.useState(false);
  const [tempProduct, setTempProduct] = React.useState(currentProduct)
  
  const location = useLocation();
  const prevProduct = usePrevious(currentProduct)
  
  React.useEffect(() => {
    
    if(location.action === "PUSH" && globalHistory.transitioning ) {
      setOpen(true)
    }

    if(prevProduct !== currentProduct){
      setTempProduct(prevProduct)
    }

  }, [prevProduct, currentProduct, location.action ]) // eslint-disable-line react-hooks/exhaustive-deps


  React.useEffect(() => {
    if(tempProduct === undefined){
      setOpen(false)
    }
  }, [tempProduct])



  return (
    <>
      { tempProduct === undefined ?
        null
        :
        <Toast.Provider swipeDirection="right">
          <Toast.Root className="ToastRoot" open={open} onOpenChange={setOpen} duration={5000}>
            <Toast.Description asChild>
                <div className="ToastDescription">
                    <p style={{padding: '0 0.7rem'}}>Your product changed from <br/> <span style={{fontStyle: 'italic', fontWeight: 'bold', textTransform: 'capitalize'}}>{tempProduct}</span> to <span style={{fontStyle: 'italic', fontWeight: 'bold', textTransform: 'capitalize'}}>{currentProduct}</span>.</p>
                </div>
            </Toast.Description>
          </Toast.Root>
          <Toast.Viewport className="ToastViewport" />
        </Toast.Provider>
      }
    </>
  );
}, ((cur, prev) => cur === prev))

ToastProductChange.propTypes = {
  currentProduct: PropTypes.string.isRequired
}

export default ToastProductChange;